import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  containerStyle: (isSearchable, zIndex) => ({
    ...(Platform.OS !== 'android' && {
      zIndex,
    }),
    marginTop: isSearchable ? 49 : 20,
  }),
  arrow: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  dropDownBox: (top, zIndex) => ({
    marginHorizontal: '3%',
    borderTopRightRadius: 5,
    borderTopLeftRadius: 5,
    borderBottomRightRadius: 5,
    borderBottomLeftRadius: 5,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    width: '94%',
    backgroundColor: 'transparent',
    borderRadius: 0,
    borderWidth: 0,
    top: top,
    maxHeight: Platform.OS === 'ios' ? 162 : 168,
    zIndex: zIndex,
  }),
  hidden: {
    position: 'relative',
    display: 'none',
    borderWidth: 0,
  },
  dividerContainer: {
    paddingHorizontal: 9,
    paddingVertical: 19,
  },
  divider: (width, height, theme, color) => ({
    height,
    width,
    backgroundColor: color || theme.colors.divider,
    marginTop: 20,
    paddingHorizontal: 40,
  }),
});
